import css from '../CTAButton.module.scss';
import { useLocalization } from '../../../../context/Localization/localization';
import { WebCTAButtonDisplayProps } from './WebCTAButtonDisplay.types';
import { ReactNode } from 'react';
import { GMSizedIcon } from '../../../Icon';

/**
 * The styling and display control for the Web CTA Button.
 *
 * @param label - {@link WebCTAButtonDisplayProps.label label} description.
 * @param sizedIcon - {@link WebCTAButtonDisplayProps.sizedIcon sizedIcon} description.
 * @param hideIcon - {@link WebCTAButtonDisplayProps.hideIcon hideIcon} description.
 * @param dataTestid - {@link WebCTAButtonDisplayProps.dataTestid dataTestid} description.
 */
export const WebCTAButtonDisplay = ({
    label,
    sizedIcon,
    hideIcon,
    dataTestid,
}: WebCTAButtonDisplayProps): ReactNode => {
    const Localization = useLocalization();

    return (
        <div
            data-testid={dataTestid}
            className={css.webCTAButton}
            role={'presentation'}
        >
            <div>{label}</div>
            {!hideIcon && (sizedIcon ?
                sizedIcon :
                <div className={css.arrowIcon}>
                    <GMSizedIcon
                        iconType={'Arrow'}
                        iconSize={'medium'}
                        ariaLabel={Localization.ProceedArrow}
                    />
                </div>
            )}
        </div>
    );
};
